import React from "react";

const ITEMS = [
  "MADE FRESH FOR REAL ROUTINES",
  "GOLD OR PURPLE",
  "JAR OR POUCH",
  "START PLAIN · KEEP IT SIMPLE",
  "UK DELIVERY",
  "MARKETPLACE FEEDBACK",
];

const LINE = ITEMS.join(" · ");

function MarqueeHalf({ suffix }) {
  return (
    <div className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={`${suffix}-${item}-${i}`} className="flex items-center shrink-0">
          <span className="px-5 text-[11px] tracking-[0.16em] uppercase font-medium text-ivory/85 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-[10px] shrink-0" aria-hidden>
            ·
          </span>
        </span>
      ))}
    </div>
  );
}

export default function HomeAnnouncementStrip() {
  return (
    <div
      className="home-marquee-strip relative border-b border-[rgba(248,241,223,0.14)] bg-[color:var(--mm-panel-warm)] text-ivory"
      role="region"
      aria-label="Moss Matrix highlights"
    >
      <p className="sr-only">{LINE}</p>
      <div className="home-marquee-static px-4 py-2.5 text-center text-[11px] tracking-[0.08em] uppercase text-ivory/85 font-medium leading-relaxed break-words">
        {LINE}
      </div>
      <div className="home-marquee-live py-2.5 overflow-hidden" aria-hidden>
        <div className="home-marquee-track flex w-max items-center">
          <MarqueeHalf suffix="a" />
          <MarqueeHalf suffix="b" />
        </div>
      </div>
    </div>
  );
}
